import ROUTE from 'constant/route'
import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const useOrderQuery = () => {
    const history = useHistory()
    const { search, pathname } = useLocation()
    const orderId = useMemo(() => {
        const searchParams = new URLSearchParams(search)
        return searchParams.get('id') || undefined
    }, [search])

    const tableGroupID = useMemo(() => {
        const searchParams = new URLSearchParams(search)
        return searchParams.get('tableGroupID') || undefined
    }, [search])

    const tableID = useMemo(() => {
        const searchParams = new URLSearchParams(search)
        return searchParams.get('tableID') || undefined
    }, [search])

    const redirectToOrder = useCallback(
        (oId?: string, forceReplace: boolean = false) => {
            const searchParams = oId ? '?id=' + oId : undefined
            if (
                ((pathname === ROUTE.QUICK_SERVICE ||
                    pathname === ROUTE.ORDERS) &&
                    orderId) ||
                forceReplace
            )
                history.replace({
                    pathname: ROUTE.QUICK_SERVICE,
                    search: searchParams,
                })
            else
                history.push({
                    pathname: ROUTE.QUICK_SERVICE,
                    search: searchParams,
                })
        },
        [history, orderId, pathname],
    )
    const redirectToTable = useCallback(
        (
            order?: {
                orderID?: string
                tableID?: string
                tableGroupID?: string
            },
            forceReplace: boolean = false,
        ) => {
            const searchParams =
                (order?.tableGroupID
                    ? `?tableGroupID=${order.tableGroupID!}`
                    : order?.tableID
                    ? `?tableID=${order?.tableID!}`
                    : '') + (order?.orderID ? '&id=' + order.orderID : '')

            if (
                ((pathname === ROUTE.TABLE_SERVICE ||
                    pathname === ROUTE.ORDERS) &&
                    (tableGroupID || tableID)) ||
                forceReplace
            )
                history.replace({
                    pathname: ROUTE.TABLE_SERVICE,
                    search: searchParams,
                })
            else
                history.push({
                    pathname: ROUTE.TABLE_SERVICE,
                    search: searchParams,
                })
        },
        [history, pathname, tableGroupID, tableID],
    )
    return { orderId, tableGroupID, tableID, redirectToTable, redirectToOrder }
}
export default useOrderQuery
